module.exports = __webpack_public_path__ + "static/media/matthias-drilling.62c0d5c1.jpg";